import React from 'react'
import { AdminCatalogueView as View } from './Catalogue';
import { Library, Layers, Users2 } from "lucide-react"; // Consistent stroke weight
import { Separator } from '../ui/separator';
import { ButtonShadcn } from '../ui/button-shadcn';
import { cn } from "@/lib/utils";

interface IAdminModalSidebar {
  view: View;
  onNavigate: (view: View) => void;
}

const AdminModalSidebar = ({ view, onNavigate }: IAdminModalSidebar) => {
  const isDetailView = ['USER_DETAIL', 'GROUP_DETAIL', 'GROUP_CREATE'].includes(view);
  if (isDetailView) return null;

  const navItems = [
    { id: 'CATALOGUE', label: 'Catalogue', icon: Library },
    { id: 'GROUPS', label: 'Groups', icon: Layers },
    { id: 'USERS', label: 'Users', icon: Users2 },
  ] as const;

  return (
    <aside className="w-28 flex flex-col h-full border-r bg-muted/20">
      <div className="p-4 flex flex-col items-center">
        <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-4">
          Admin
        </span>
        
        <nav className="flex flex-col space-y-4 w-full">
          {navItems.map((item, index) => (
            <React.Fragment key={item.id}>
              <ButtonShadcn
                variant="ghost"
                className={cn(
                  "flex flex-col items-center justify-center h-20 w-full rounded-xl transition-all duration-200",
                  view === item.id
                    ? "bg-background shadow-sm text-primary hover:bg-background"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}
                onClick={() => onNavigate(item.id)}
                data-testid={`sidebar-${item.id.toLowerCase()}`}
              >
                <item.icon className={cn("h-6 w-6 mb-1", view === item.id ? "stroke-[2.5px]" : "stroke-[1.5px]")} />
                <span className="text-[11px] font-medium">{item.label}</span>
              </ButtonShadcn>
              {index < navItems.length - 1 && <Separator className="bg-border/50 mx-2" />}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </aside>
  )
}

export default AdminModalSidebar